import { render, staticRenderFns } from "./AUFooter.vue?vue&type=template&id=493f2616&"
import script from "./AUFooter.vue?vue&type=script&lang=js&"
export * from "./AUFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports